import React, { Component } from 'react'
import { connect } from 'react-redux'
import './index.scss'

import AnimationCount from 'react-count-animation'

import { Trans } from 'react-i18next'
import i18n from '../../../i18n'

class MainSection extends Component {
    hashtag = {
        ko: [
            { label: "#광고", value: "광고" },
            { label: "#교육", value: "교육" },
            { label: "#SNS일상", value: "일상" },
        ],
        en: [
            { label: "#advertising", value: "advertising" },
            { label: "#education", value: "education" },
            { label: "#daily", value: "daily" },
        ],
        jp: [
            { label: "#動画広告", value: "広告" },
            { label: "#教育", value: "教育" },
            { label: "#日常", value: "日常" },
        ]
    }

    setVideoPlayback = ref => {
        if (ref) {
            ref.playbackRate = 1.4
        }
    }

    render() {
        const { lang: orgLang } = this.props
        let { lang } = this.props
        const { history, totalTemplateCount } = this.props
        const settings = {
            start: 0,
            count: totalTemplateCount,
            duration: 3000,
            animation: 'up',
        }
        if (!this.hashtag[lang]) lang = 'en'

        const isChristmas = false

        return (
            <div className={`old-main-section-root-container ${isChristmas && 'christmas'}`}>
                <div className={`left-area ${orgLang}`}>
                    <div className='title'>
                        <Trans i18nKey="web.newhome.main.section.title">
                            <br />
                            <b />
                        </Trans>
                    </div>
                    <div className='desc'>
                        <span className='count'>
                            <Trans i18nKey="web.newhome.main.section.count">
                                <AnimationCount {...settings} />
                                <span className='unit' />
                            </Trans>
                        </span>
                        <br />
                        <Trans i18nKey="web.newhome.main.section.desc">
                            <span className='border-bottom' />
                            <br />
                        </Trans>
                    </div>
                    <div className='hashtag-area'>
                        {
                            this.hashtag[lang].map(({ label, value }) => (
                                <span onClick={() => this.props.handleClickHashtag(value)}>{label}</span>
                            ))
                        }
                    </div>
                    <div
                        className='move-btn'
                        onClick={() => history.push('/designselect')}
                    >
                        {isChristmas && <img className="ribbon" src="https://front.videomonster.com/images-u6yd72dy/web/home/christmas-move-btn-icon.svg" alt="" />}
                        {i18n.t("web.newhome.main.section.movebtn")}
                        {isChristmas && <div className="empty-area" />}
                    </div>
                </div>
                <div className='right-area'>
                    {
                        !isChristmas &&
                        <>
                            <div className='circle-wrapper'>
                                <div className='circle1' />
                                <div className='circle2' />
                                <div className='circle3' />
                            </div>
                            <img className='img-galaxy' src='https://front.videomonster.com/images-u6yd72dy/web/home/main-section-galaxy.png' alt='' />
                            <img className='img-ipad' src='https://front.videomonster.com/images-u6yd72dy/web/home/main-section-ipad.png' alt='' />
                            <div className='notebook-wrapper'>
                                <img src='https://front.videomonster.com/images-u6yd72dy/web/home/main-section-notebook.png' alt='' />
                                <video src="https://videomonsterpublic.blob.core.windows.net/00websitefile/videos/home/tutorial_en.mp4" muted autoPlay loop play ref={this.setVideoPlayback} />
                            </div>
                        </>
                    }
                </div>
            </div>
        )
    }
}

const mapStateToProps = state => ({
    lang: state.langStore.lang
})

export default connect(mapStateToProps, null)(MainSection)